import React from "react";
import {ReactComponent as VoiceIcon} from "../images/voice-icon.svg";
import {ReactComponent as ChatIcon} from "../images/chat-icon.svg";
import {Message} from "../types/types";

type Props = {
  messages: Message[];
  isExpanded: boolean;
  inputValue: string;
  setInputValue: (val: string) => void;
  onSubmit: () => void;
  isDisabled?: boolean;
  hasStartedChat: boolean;
};

const ChatInput: React.FC<Props> = ({
  inputValue,
  isExpanded,
  setInputValue,
  onSubmit,
  messages,
  isDisabled = false,
  hasStartedChat,
}) => {
  return (
    <div
      className={`iris-input-wrapper ${hasStartedChat ? "active" : isExpanded && "activeDesktop"}`}>
      <input
        type="text"
        name="iris-input"
        placeholder={
          isDisabled
            ? "Please wait for the bot to respond..."
            : "How can I help?"
        }
        className="iris-input"
        value={inputValue}
        onChange={(e) => !isDisabled && setInputValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !isDisabled) {
            e.preventDefault();
            onSubmit();
          }
        }}
        aria-label="Chat input"
        autoComplete="off"
        disabled={isDisabled}
      />
      <button
        className="iris-mic-button"
        onClick={!isDisabled ? onSubmit : undefined}
        disabled={isDisabled || !inputValue.trim()}
        aria-label="Submit message">
        <span className="iris-mic-icon">
          {inputValue.trim() === "" ? <VoiceIcon /> : <ChatIcon />}
        </span>
      </button>
    </div>
  );
};

export default ChatInput;
